import { render, staticRenderFns } from "./FormularioReceta.vue?vue&type=template&id=9ae0d6ec&scoped=true"
import script from "./FormularioReceta.vue?vue&type=script&lang=js"
export * from "./FormularioReceta.vue?vue&type=script&lang=js"
import style0 from "./FormularioReceta.vue?vue&type=style&index=0&id=9ae0d6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae0d6ec",
  null
  
)

export default component.exports